<template>
  <div class="from_box flex">
    <div class="item">
      <span class="txt">公司：</span>
      <el-select v-model="fromData.companyId" @change="changeCompany" placeholder="请选择公司" :disabled = "origin">
        <el-option
          v-for="item in companyList"
          :label="item.value"
          :key="item.companyId"
          :value="item.companyId"
        >
        </el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt">销售订单：</span>
      <el-input
        v-model="fromData.customerPurchCode"
        :disabled="isFactoryInventory"
		    placeholder="系统给值"
      ></el-input>
    </div>

    <div class="item">
      <span class="txt">订单类型：</span>
      <el-select v-model="fromData.saleVoucherTypeDesc" @focus="focusSaleVoucherType" @change="changeSaleVoucherType" :disabled = "origin" placeholder="请选择订单类型">
        <el-option
          v-for="item in this.saleVoucherTypeList"
          :label="item.value"
          :key="item"
          :value="item"
        ></el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt">分销渠道：</span>
      <el-select v-model="fromData.distriChannelDesc" @focus="distriChannelType" @change="changeDistriChannel" :disabled = "origin" placeholder="请选择分销渠道">
        <el-option
          v-for="item in this.distriChannelList"
          :label="item.value"
          :key="item"
          :value="item"
        ></el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt">客户：</span>
      <el-select v-model="fromData.customerId" @change="changeCustomer"  :disabled = "origin" placeholder="请选择客户">
        <el-option
          v-for="item in customerList"
          :label="item.value"
          :key="item.customerId"
          :value="item.customerId"
          @select="handleSelect"
        ></el-option>
      </el-select>
    </div>

    <div class="item">
      <span class="txt">单据日期：</span>
      <el-date-picker v-model="fromData.postingDate" type="date" :disabled = "origin" placeholder="选择日期"></el-date-picker>
    </div>
    <div class="item">
      <span class="txt">联系人：</span>
      <el-input
        v-model="fromData.orderer"
		    placeholder="暂无联系人"
        :disabled = "origin"
      ></el-input>
    </div>

    <div class="item">
      <span class="txt">联系电话：</span>
      <el-input
        v-model="fromData.telephone"
		    placeholder="暂无电话"
        :disabled = "origin"
      ></el-input>
    </div>

    <div class="item">
      <span class="txt">送货地址：</span>
      <el-input
        v-model="fromData.address"
		    placeholder="暂无地址"
        :disabled = "origin"
      ></el-input>
    </div>
    <!-- <div class="item" v-if="origin">
      <span class="txt">是否来源线上：</span>
      <el-input
        v-model="origin"
		    placeholder="暂无"
        :disabled = "origin"
      ></el-input>
    </div> -->

    <div class="item">
      <span class="txt" style="margin-left:-4%">是否来源线上：</span>
      <el-checkbox style="margin-top:8px" v-model="origin" disabled></el-checkbox>
    </div>
  </div>
</template>

<script>
import { fstockApi, customerApi ,factoryApi} from "api/base.js";

export default {
  components: {},
  props: {
    fromData: Object,
    noFromData: Object,
    customerList: Array,
    factoryList: Array,
    companyList: Array
  },
  data() {
    return {
      origin:false,
      saleVoucherTypeList: ["0001-普通销售订单","0002-定制销售订单"],//订单类型
      distriChannelList: ["01-零售","02-团购","03-批发"],//分销渠道
      //已选的供应商
      customerListRes: {}, 
      //已选的工厂
      factoryListRes: {},
      fstockList: [], //库存地信息
      isFactoryInventory: true, //库存地是否禁用
      downloadUrl:
        "http://192.168.2.249:8080/purchasemng/purchaseinstock/excel/tpl",
      uploadUrl:
        "http://192.168.2.249:8080/purchasemng/purchaseinstock/excel/importmaterial",
      //获取库位信息
      fromFstock: {
        page: 1,
        pageSize: 10000,
        searchCriteria: {}
      }
    };
  },
  watch:{
    'fromData.origin': function(val, old) {
      console.log(val);
      if(val == "线上"){
        this.origin = true
      }else{
        this.origin = false
      }
    },
  },
  created() {
    
    //凭证和过账默认今天
    let nowData = new Date();
    this.$set(this.fromData, "voucherDate", nowData);
    this.$set(this.fromData, "postingDate", nowData);
    
    //测试
    // this.fromData.targetUnitDesc = "瓶";
    // this.fromData.targetUnitCode = "DY";
    // this.fromData.targetUnitId = "12";
  },
  methods: {
    //客户选择后
    handleSelect(item) {
      console.log(item)
      this.fromData.customerDesc = item.customerDesc;
      this.fromData.customerId = item.customerId;
      this.fromData.customerCode = item.customerCode;
      this.fromData.customerStr = item.customerCode + "-" + item.customerName;
    },
    //公司修改
    async changeCompany(val) { 
       console.log(val)
      let obj = this.companyList.find(v=>v.companyId === val);
      if(obj){
        this.fromData.companyId = obj.companyId;
        this.fromData.companyCode = obj.companyCode;
        this.fromData.companyDesc = obj.companyName;
      }
      //工厂
				let factoryList = await this.$post(factoryApi.factoryFind,{searchCriteria:{'companyId':val}});
				if(factoryList.status){
					console.log(factoryList)
					factoryList.data.list.forEach((item)=>{
						item.factoryDisplay= item.factoryCode + "-" + item.factoryDesc;
					});
					let newArr = {'factoryDisplay':'请选择'};
					factoryList.data.list.unshift(newArr);
					this.$store.state.cache.factoryList = factoryList.data.list;
				}else{
					this.$store.state.cache.factoryList = null;
				}
    },
    //客户修改
    async changeCustomer(val) {
      let obj = this.customerList.find(v=>v.customerId === val);
      if(obj){
        console.log(obj)
        this.fromData.customerId = obj.customerId;
        this.fromData.customerCode = obj.customerCode;
        this.fromData.customerDesc = obj.customerName;
      }
    console.log(this.fromData.customerCode, "====223");
	  let customerLists = await this.$get(
		  customerApi.find,
		  {'customerId':this.fromData.customerId}
        );
    console.log(customerLists, "====---11");
    // this.$store.state.cache.customerList = customerLists.data.customerName;
    // console.log(this.$store.state.cache.customerList)
		let area = customerLists.data.area ? customerLists.data.area : "";
		let address = customerLists.data.streetAdress ? customerLists.data.streetAdress : "";
		let phone = customerLists.data.telephone ? customerLists.data.telephone : customerLists.data.mobilePhone;
		this.$set(this.fromData, "orderer", customerLists.data.contact);
		this.$set(this.fromData, "telephone", phone);
		this.$set(this.fromData, "address", area + address);
    },
    focusSaleVoucherType(){

    },
    changeSaleVoucherType(val){ 
        console.log(val)
        if(val == "0001-普通销售订单"){
          this.fromData.saleVoucherType = "0001"
          this.fromData.saleVoucherTypeDesc = "普通销售订单"
          // console.log(this.fromData)
        }
        if(val == "0002-定制销售订单"){
          this.fromData.saleVoucherType = "0002"
          this.fromData.saleVoucherTypeDesc = "定制销售订单"
          // console.log(this.fromData)
        }
    },
    distriChannelType(){

    },
    changeDistriChannel(val){
        console.log(val)
        if(val == "01-零售"){
          this.fromData.distriChannel = "01"
          this.fromData.distriChannelDesc = "零售"
          // console.log(this.fromData)
        }
        if(val == "02-团购"){
          this.fromData.distriChannel = "02"
          this.fromData.distriChannelDesc = "团购"
          console.log(this.fromData)
        }
        if(val == "03-批发"){
          this.fromData.distriChannel = "03"
          this.fromData.distriChannelDesc = "批发"
          // console.log(this.fromData)
        }
    }
  }
};
</script>

<style>
</style>
